module.exports = __webpack_public_path__ + "static/media/hero-bg.935a326f.png";